import React, { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Typography, Button } from '@mui/material';
import { PrimaryLightSelect } from '../theme/index';
import BedIcon from '@mui/icons-material/Bed';
import StartIcon from '@mui/icons-material/Start';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import WarningIcon from '@mui/icons-material/Warning';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { modalAction } from '../redux/reducers/Modal';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from '../components/SuccessModal';
import { useNavigate } from 'react-router-dom';
import roomsList, { opens, closes, level, cleans, roomTypeFilter, levelCheckoutFilter } from '../components/Rooms';
import CloseIcon from '@mui/icons-material/Close';

const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const SellProduct = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();

  const [ showModal, setShowModal ] = useState(false);
  const [ rooms, setRooms ] = useState(roomsList);
  const [ levelValue, setLevelValue ] = useState(0);
  const [ roomType, setRoomType ] = useState('all');
  const [ roomCleaning, setRoomCleaning ] = useState({});

  useEffect( () => {
    setShowModal(modalStatus);
  }, [modalStatus] );

  useEffect( () => {
    setRooms(closes(levelValue));
  }, [] );

  const filterByLevel = (value) => {
    setLevelValue(value);
    setRooms(levelCheckoutFilter(value, roomType));
  }

  const changeRoomType = (value) => {
    setRoomType(value);
    setRooms(roomTypeFilter(levelValue, value))
  }

  const btnFilter = () => {
    return ( screenWidth <= 500 ) ? { width: '100%', marginBottom: '1rem' } : { width: '90%' };
  }

  const cleaningRoom = (room) => {
    setRoomCleaning(room);
    dispatch(modalAction());
  }
  
  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Venta de productos</h2>
      </Grid>
      
      <Grid container>
        <Grid item xs={12} sm={5} md={2}>
          <FormControl sx={btnFilter()}>
            <InputLabel id="demo-simple-select-label">Nivel</InputLabel>
            <PrimaryLightSelect 
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Nivel"
              value={levelValue}
              onChange={ e => filterByLevel(e.target.value) }
            >
                <MenuItem value={0}>Todas </MenuItem>
                <MenuItem value={1}>Primer nivel </MenuItem>
                <MenuItem value={2}>Segundo nivel </MenuItem>
                <MenuItem value={3}>Tercer nivel </MenuItem>
            </PrimaryLightSelect>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={5} md={2}>
          <FormControl sx={btnFilter()}>
            <InputLabel id="demo-simple-select-label">Tipo de habitacion</InputLabel>
            <PrimaryLightSelect 
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Tipo de habitacion"
              value={ roomType }
              onChange={ e => changeRoomType(e.target.value) }
            >
                <MenuItem value='all'>Todas</MenuItem>
                <MenuItem value='double-bed'>Matrimonial</MenuItem>
                <MenuItem value='personal'>Personal</MenuItem>
                <MenuItem value='double'>Doble</MenuItem>
                <MenuItem value='junior-suite'>Junior Suite</MenuItem>
                <MenuItem value='suite'>Suite</MenuItem>
            </PrimaryLightSelect>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container sx={{ mt: 5, justifyContent: 'space-between' }}>
        {
          rooms.length == 0 &&
          <Typography sx={{ display: 'flex', alignItems: 'center', mt: 4 }} >
            <CloseIcon sx={{ color: 'secondary.main', mr: 2 }} /> 
            No hay ninguna habitacion con este filtro.
          </Typography>
        }
        {
          rooms.map( (item, index) => {
              return (
                <Room key={index} item xs={12} sm={5} md={3} sx={{ backgroundColor: 'secondary.main', color: '#FFF', mr: 1, mb: 4 }} onClick={ () => navigate(`/sellproduct/${item.code}`) }>
                  <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', padding: '1.5rem 0' }}>
                    <div style={{ display: 'inline', width: '100%' }}>
                      <h2 style={{ display: 'inline' }}>{item.code}</h2>
                      <br/>
                      <p style={{ display: 'inline' }}>{item.type}</p>
                    </div>
                    <div style={{ width: '100%' }}>
                      <HotelOutlinedIcon style={{ fontSize: '8rem' }} />
                    </div>
                  </div>
                  <Typography sx={{ backgroundColor: 'secondary.light', width: '100%', my: 0, textAlign: 'center', py: .5, display: 'flex', 
                                    alignItems: 'center', justifyContent: 'center' }}>
                    Ocupada 
                    <WarningIcon sx={{ ml: 1 }} />
                  </Typography>
                </Room>
              )
          } )
        }

      </Grid>
    </Grid>
  )
}

export default SellProduct